module.exports = __webpack_public_path__ + "static/media/discover-se-si-console.08c159a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/GettingStarted/Platform/images/discover-se-si-console.png
// module id = 1172
// module chunks = 0